/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 11/20/2019
 *
 */

import React from 'react';

import EventEmitter from "../../eventEmmiters/EventEmitter";
import Card from "../../components/generic/card/card";
import '../common.css';
import CardIconContainer from "../../components/generic/card/cardIconContainer";
import CardIcon from "../../components/generic/card/cardIcon";
import CardHeader from "../../components/generic/card/cardHeader";
import '../../components/generic/card/card.css';
import CardHeaderTextContainer from "../../components/generic/card/cardHeaderTextContainer";
import CardFooter from "../../components/generic/card/cardFooter";
import CardContainer from "../../components/generic/card/cardContainer";
import GraphContainer from "../../components/generic/graph/graphContainer";
import Graph from "../../components/generic/graph/graph";
import {dailySalesChart, emailsSubscriptionChart} from "../../components/generic/graph/graphData";
import GraphCard from "../../components/generic/graph/graphCard";

class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        EventEmitter.emit('setPageHeaderData', {
            page: 'dashboard',
            pageName: "Dashboard",
            pageLink: process.env.REACT_APP_BASE_URL + "/#/home",
            optionalIcons: []
        });
    }

    render() {
        return(
            <div className='main-layout'>
                <CardContainer>
                    <Card>
                        <CardHeader>
                            <CardIconContainer color='yellow'>
                                <CardIcon icon="user"/>
                            </CardIconContainer>
                            <CardHeaderTextContainer style={{flexGrow: '1', paddingRight: '5%'}}>
                                <p className='cardHeaderTop'>Application Users</p>
                                <h3 className='cardTitle'>
                                    230
                                </h3>
                            </CardHeaderTextContainer>
                        </CardHeader>
                        <CardFooter>
                            <div className="footerContent">
                                <i className="fa fa-user-plus" />
                                Admins
                                <span>15</span>
                            </div>
                            <div className="footerContent">
                                <i className="fa fa-male" />
                                Users
                                <span>15</span>
                            </div>
                            <div className="footerContent">
                                <i className="fa fa-odnoklassniki" />
                                Operation Users
                                <span>15</span>
                            </div>
                        </CardFooter>
                    </Card>
                    <Card>
                        <CardHeader>
                            <CardIconContainer color='red'>
                                <CardIcon/>
                            </CardIconContainer>
                            <CardHeaderTextContainer style={{flexGrow: '1', paddingRight: '5%'}}>
                                <p className='cardHeaderTop'>Total Partners</p>
                                <h3 className='cardTitle'>
                                    230
                                </h3>
                            </CardHeaderTextContainer>
                        </CardHeader>
                        <CardFooter>
                            <div className="footerContent">
                                <i className="fa fa-bars" />
                                Enabled Partners
                                <span>15</span>
                            </div>
                            <div className="footerContent">
                                <i className="fa fa-bars" />
                                Disabled Partners
                                <span>15</span>
                            </div>
                        </CardFooter>
                    </Card>
                    <Card>
                        <CardHeader>
                            <CardIconContainer color='blue'>
                                <CardIcon/>
                            </CardIconContainer>
                            <CardHeaderTextContainer style={{flexGrow: '1', paddingRight: '5%'}}>
                                <p className='cardHeaderTop'>Total Partners</p>
                                <h3 className='cardTitle'>
                                    230
                                </h3>
                            </CardHeaderTextContainer>
                        </CardHeader>
                        <CardFooter>
                            <div className="footerContent">
                                <i className="fa fa-bars" />
                                Enabled Partners
                                <span>15</span>
                            </div>
                            <div className="footerContent">
                                <i className="fa fa-bars" />
                                Disabled Partners
                                <span>15</span>
                            </div>
                        </CardFooter>
                    </Card>
                    <Card>
                        <CardHeader>
                            <CardIconContainer>
                                <CardIcon/>
                            </CardIconContainer>
                            <CardHeaderTextContainer style={{flexGrow: '1', paddingRight: '5%'}}>
                                <p className='cardHeaderTop'>Total Partners</p>
                                <h3 className='cardTitle'>
                                    230
                                </h3>
                            </CardHeaderTextContainer>
                        </CardHeader>
                        <CardFooter>
                            <div className="footerContent">
                                <i className="fa fa-bars" />
                                Enabled Partners
                                <span>15</span>
                            </div>
                            <div className="footerContent">
                                <i className="fa fa-bars" />
                                Disabled Partners
                                <span>15</span>
                            </div>
                        </CardFooter>
                    </Card>
                </CardContainer>
                <GraphContainer>
                    <GraphCard>
                        <Graph name={dailySalesChart}/>
                    </GraphCard>
                    <GraphCard>
                        <Graph name={emailsSubscriptionChart}/>
                    </GraphCard>
                </GraphContainer>
            </div>
        )
    }
}

export default Dashboard;
